import './InvoiceListComponent.scss';
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import CardComponent from "../../../shared/components/card/CardComponent";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../shared/components/status-card/StatusCardComponent";
import ListInfoCardComponent from "../../../shared/components/list-info-card/ListInfoCardComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import SecureCheckoutComponent from "../../transaction/secure-checkout/SecureCheckoutComponent";

interface InvoiceListComponentProps {

}

const InvoiceListComponent = (props: InvoiceListComponentProps) => {

    const [isPendingPaymentListLoading, setIsPendingPaymentListLoading] = useState(false);
    const [isPendingPaymentListLoadingFailed, setIsPendingPaymentListLoadingFailed] = useState(false);
    const [isPendingPaymentListLoaded, setIsPendingPaymentListLoaded] = useState<boolean>(false);
    const [pendingPaymentList, setPendingPaymentList] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<string>('');

    const getPendingPaymentList = useCallback(() => {
        setIsPendingPaymentListLoading(true);
        setIsPendingPaymentListLoadingFailed(false);
        setIsPendingPaymentListLoaded(false);
        CommonService._transaction.PendingPaymentList()
            .then((response: any) => {
                setPendingPaymentList(response.data.docs);
                setIsPendingPaymentListLoading(false);
                setIsPendingPaymentListLoaded(true);
                setIsPendingPaymentListLoadingFailed(false);
            })
            .catch((error: any) => {
                setIsPendingPaymentListLoading(false);
                setIsPendingPaymentListLoadingFailed(true);
                setIsPendingPaymentListLoaded(true);
                setPendingPaymentList([]);
            });

    }, []);

    useEffect(() => {
        getPendingPaymentList();
    }, [getPendingPaymentList]);

    const handleOpenModal = (id: string) => {
        setSelectedId(id);
        setIsModalOpen(true);
    }

    return (
        <div className="invoice-list-component">
            <CardComponent>
                <div className={'invoice-list-header'}>
                    <div className={'invoice-list-header-title'}>Pending Payments</div>
                    <LinkComponent route={CommonService._routeConfig.Transaction()}>Show More</LinkComponent>
                </div>
                {
                    isPendingPaymentListLoading && <LoaderComponent/>
                }
                {
                    isPendingPaymentListLoadingFailed &&
                    <StatusCardComponent title={'Failed to fetch pending payments'}/>
                }
                {
                    isPendingPaymentListLoaded &&
                    <div className={'invoice-list-container'}>
                        {
                            pendingPaymentList?.length > 0 && pendingPaymentList?.map((item: any, index: number) => {
                                return (
                                    <div key={index} className={'mrg-bottom-10'}>
                                        <ListInfoCardComponent action={<ButtonComponent size={'small'}
                                                                                        onClick={() => {
                                                                                            if (item?.enable_pay_now === false) {
                                                                                                CommonService._alert.showToast('This appointment has been marked as cancelled or no-show. Payment is not allowed unless the status is updated by the admin.')
                                                                                            } else {
                                                                                                handleOpenModal(item._id)
                                                                                            }
                                                                                        }}
                                                                                        color={'error'}
                                                                                        variant={'outlined'}>
                                            Pay Now
                                        </ButtonComponent>
                                        } prefixIcon={'$'} value={item.payable_amount}
                                                               description={`${item?.service_details?.name} | ${CommonService.transformTimeStamp(item.created_at)}`}/>
                                    </div>
                                )
                            })
                        }
                        {
                            pendingPaymentList?.length === 0 &&
                            <div className={'status-wrapper'}>
                                <StatusCardComponent title={'No pending payments.'}/>
                            </div>
                        }
                    </div>
                }
            </CardComponent>
            <ModalComponent isOpen={isModalOpen}
                            onClose={() => {
                                getPendingPaymentList();
                                setIsModalOpen(false);
                                setSelectedId('');
                            }}

            >
                <SecureCheckoutComponent isComingFromListScreen={true} setIsSecureCheckOutModalOpen={setIsModalOpen}
                                         location={'dashboard'}
                                         refreshPaymentList={getPendingPaymentList}
                                         selectedId={selectedId}/>

            </ModalComponent>
        </div>
    )
}
export default InvoiceListComponent;
